import type { FC } from 'react';

import { spinnerCurrentColorClass, spinnerIconClass } from './SpinnerIcon.css';
import { getClassNames } from '../../util/css';
import { IconProps } from '../IconWrapper';
import { svgIconRecipe } from '../IconWrapper.css';

const sparkyClassName = 'sparky-spinner';

const SpinnerIcon: FC<IconProps> = ({ color = 'currentColor', size }) => (
  <svg
    viewBox="25 25 50 50"
    aria-hidden="true"
    className={getClassNames(
      sparkyClassName,
      spinnerIconClass,
      svgIconRecipe({ stroke: color === 'currentColor' ? undefined : color, size }),
      color === 'currentColor' && spinnerCurrentColorClass,
    )}>
    <circle fill="none" cx="50" cy="50" r="20" />
  </svg>
);

export default SpinnerIcon;

SpinnerIcon.toString = () => `.${sparkyClassName}`;
